// Keeps a `--header-height` CSS custom property in sync with the actual
// rendered height of the fixed <header>, so anything meant to sit flush
// against its bottom edge (e.g. .menu-holder) never has to guess/hardcode a
// pixel value per breakpoint — a value that silently drifts the moment the
// header's own height changes (padding, logo size, content) without every
// dependent rule being updated to match.
export default function initHeaderHeightVar() {
  const header = document.querySelector('header') as HTMLElement | null
  if (!header) {
    return
  }

  const setHeaderHeightVar = () => {
    document.documentElement.style.setProperty('--header-height', `${header.offsetHeight}px`)
  }

  setHeaderHeightVar()

  // ResizeObserver catches every real change to the header's own box (a
  // breakpoint changing its padding, the logo swapping size, content
  // reflowing after fonts load, etc.) — more precise and reliable than a
  // plain window "resize" listener, which only fires for viewport changes.
  const resizeObserver = new ResizeObserver(setHeaderHeightVar)
  resizeObserver.observe(header)
}
